export default __webpack_public_path__ + "images/sunnspirasjon_bg_dark.jpeg";